import * as React from 'react'
import { SVGProps } from 'react'

const SvgTelegramIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='m9.778 18.646.282-4.225 7.685-6.934c.337-.3-.074-.446-.522-.174l-9.485 5.984-4.097-1.279c-.885-.27-.891-.879.199-1.316l15.966-6.158c.729-.33 1.433.175 1.154 1.291l-2.72 12.813c-.19.91-.74 1.128-1.501.708l-4.141-3.06-1.992 1.936c-.23.226-.414.414-.828.414z'
      fill='#3071EE'
    />
  </svg>
)

export default SvgTelegramIcon
